/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AgentEventSubject,
  AgentEventSubject$inboundSchema,
} from "./agenteventsubject.js";

export const AgentPresenceEventStatus = {
  Online: "online",
  Offline: "offline",
  Dormant: "dormant",
} as const;
export type AgentPresenceEventStatus = OpenEnum<
  typeof AgentPresenceEventStatus
>;

/**
 * Event indicating that an agent has gone on- or offline.
 */
export type AgentPresenceEvent = {
  status: AgentPresenceEventStatus;
  /**
   * RFC3339 formatted time in UTC
   */
  statusAt: Date;
  /**
   * The subject of an AgentPresenceEvent.
   */
  subject: AgentEventSubject;
};

/** @internal */
export const AgentPresenceEventStatus$inboundSchema: z.ZodType<
  AgentPresenceEventStatus,
  z.ZodTypeDef,
  unknown
> = openEnums.inboundSchema(AgentPresenceEventStatus);

/** @internal */
export const AgentPresenceEvent$inboundSchema: z.ZodType<
  AgentPresenceEvent,
  z.ZodTypeDef,
  unknown
> = z.object({
  status: AgentPresenceEventStatus$inboundSchema,
  status_at: types.date(),
  subject: AgentEventSubject$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "status_at": "statusAt",
  });
});

export function agentPresenceEventFromJSON(
  jsonString: string,
): SafeParseResult<AgentPresenceEvent, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AgentPresenceEvent$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AgentPresenceEvent' from JSON`,
  );
}
